module.exports = "./dist/img/no-profile.a11ba6ff.jpg";